
// FlxRx Trust Badge Injector v1.0
(function() {
  function fixEmptyCartPath() {
    const emptyButtons = document.querySelectorAll('.cart-items__empty-button');
    emptyButtons.forEach(function(button) {
      if (!button || button.dataset.flxrxCartFixed === 'true') return;
      button.href = '/collections/creatine';
      button.textContent = 'Shop Creatine';
      button.dataset.flxrxCartFixed = 'true';
    });
  }

  function fixCachedRouteLinks(root) {
    var cleanRoutes = {
      '/': '/?view=none',
      '/collections/l-carnitine': '/collections/l-carnitine?view=none',
      '/pages/flxrx-athletes': '/pages/flxrx-athletes?view=none'
    };
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function(link) {
      var rawHref = link.getAttribute('href') || '';
      var pathname = '';
      try {
        var url = new URL(rawHref, window.location.origin);
        if (url.origin !== window.location.origin) return;
        pathname = url.pathname;
      } catch (e) {
        pathname = rawHref.split('?')[0].split('#')[0];
      }
      if (cleanRoutes[pathname]) link.setAttribute('href', cleanRoutes[pathname]);
    });
  }

  function injectTrustBadges() {
    // Only run on product pages
    if (!document.body.classList.contains('template-product') && !window.location.pathname.includes('/products/')) return;
    
    // Don't inject twice
    if (document.querySelector('.flxrx-trust-strip')) return;

    var path = window.location.pathname.toLowerCase();
    var thirdBadge = 'Quality Checked';
    if (path.indexOf('liquid-l-carnitine') !== -1) {
      thirdBadge = '3000mg L-Carnitine';
    } else if (path.indexOf('creatine') !== -1) {
      thirdBadge = '100% Pure Creatine';
    }

    const trustHTML = `<div class="flxrx-trust-strip">
      <span class="flxrx-trust-item">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E91C4C" stroke-width="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        Third-Party Tested
      </span>
      <span class="flxrx-trust-item">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E91C4C" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
        Ships in 24-48 hrs
      </span>
      <span class="flxrx-trust-item">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E91C4C" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
        ${thirdBadge}
      </span>
      <span class="flxrx-trust-item">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E91C4C" stroke-width="2.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
        Made in USA
      </span>
    </div>`;

    // Find injection point: after the buy-buttons block span
    const target = document.querySelector('span[class*="buy-buttons-block"]');
    if (target) {
      target.insertAdjacentHTML('afterend', trustHTML);
      return;
    }
    // Fallback: after the product form
    const form = document.querySelector('product-form-component, form[action*="/cart/add"]');
    if (form) {
      form.insertAdjacentHTML('afterend', trustHTML);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      fixEmptyCartPath();
      fixCachedRouteLinks(document);
      injectTrustBadges();
    });
  } else {
    fixEmptyCartPath();
    fixCachedRouteLinks(document);
    injectTrustBadges();
  }

  if (window.MutationObserver) {
    new MutationObserver(function(mutations) {
      fixEmptyCartPath();
      mutations.forEach(function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function(node) {
          if (node.nodeType === 1) fixCachedRouteLinks(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
